import { cn } from '@shared/utils/utils';
import * as React from 'react';

function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');
}

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { 'data-testid'?: string; selectAllOnFocus?: boolean }
>(
  (
    { className, type, id, placeholder, 'data-testid': testId, selectAllOnFocus, onFocus, onMouseDown, ...props },
    ref,
  ) => {
    const generatedTestId =
      testId ?? (id ? `input-${slugify(id)}` : placeholder ? `input-${slugify(placeholder)}` : 'input');

    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'bg-card-bg border-card-border text-foreground',
          className,
        )}
        ref={ref}
        id={id}
        placeholder={placeholder}
        data-testid={generatedTestId}
        onFocus={(e) => {
          onFocus?.(e);
          const shouldSelectAll = selectAllOnFocus ?? type === 'number';
          if (!shouldSelectAll) return;
          requestAnimationFrame(() => {
            try {
              e.currentTarget.select();
            } catch {
              // Algunos navegadores restringen selección en type="number"
            }
          });
        }}
        onMouseDown={(e) => {
          onMouseDown?.(e);
          const shouldSelectAll = selectAllOnFocus ?? type === 'number';
          if (!shouldSelectAll) return;
          e.preventDefault();
          e.currentTarget.focus();
          requestAnimationFrame(() => {
            try {
              e.currentTarget.select();
            } catch {
              // Algunos navegadores restringen selección en type="number"
            }
          });
        }}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
